import {
  checkAllData
} from '@/cllib'

import {
  updateInvoicingData
} from '@/api/oli_api'

// 石油相关
const state = {
  hisGasList: [],
  selectHisGas: null,
  hisJxcDatas: [],
  areaHisJxcDatas: [],
  errorHisJxcDatas: [],
  allAreas: []
}

export let goUpdateInvoicingData = function (data) {
  let parm = {
    which: data.data,
    data: {
      key: data.key,
      value: data.value
    }
  }
  updateInvoicingData(parm).then(function (reData) {
    console.log(reData)
  }).catch(function (e) {
    console.log(e)
  })
}

const getters = {
  hisGasList: state => state.hisGasList,
  selectHisGas: state => state.selectHisGas,
  hisJxcDatas: state => state.hisJxcDatas,
  errorHisJxcDatas: state => state.errorHisJxcDatas,
  areaHisJxcDatas: state => state.areaHisJxcDatas,
  allAreas: tate => state.allAreas
}

const actions = {
  setAllAreas ({ commit }, data) {
    commit('setAllAreas', data)
  },
  filteHisJxcDatas ({ commit, getters }, {area, oilType}) {
    let data = []
    if (area) {
      getters.hisJxcDatas.forEach((itemA) => {
        itemA['data'].forEach((item) => {
          if (item['区域'] === area && (!item['油品名称'] || item['油品名称'].indexOf(oilType)) > -1) {
            data.push(item)
          }
        })
      })
    }
    commit('setAreaHisJxcDatas', data)
  },
  editOneHisJxcData ({ commit }, data) {
    commit('editOneHisJxcData', data)
  },
  updateErrorHisJxcDatas ({ getters, dispatch }) {
    let newData = []
    getters.errorHisJxcDatas.forEach(function (item) {
      let datas = []
      getters.hisJxcDatas.forEach((itemData) => {
        if (itemData.oil === item['加油站名称']) {
          datas = itemData.data
        }
      })
      if (!checkAllData(item, datas)) {
        newData.push(item)
      }
    })
    dispatch('setErrorHisJxcDatas', newData)
  },
  hlErrorHisJxcDatas ({ dispatch }) {
    dispatch('setErrorHisJxcDatas', [])
  },
  checkHisJxcData ({commit, getters, dispatch}) {
    // 数据校验
    setTimeout(function () {
      let errorData = []
      getters.hisJxcDatas.forEach(function (itemData) {
        itemData.data.forEach(function (itemD) {
          if (!checkAllData(itemD, itemData.data)) {
            errorData.push(itemD)
          }
        })
      })
      dispatch('setErrorHisJxcDatas', errorData)
    }, 200)
  },
  dealDatasToHisJxcDatas ({ dispatch }, data) {
    let dealData = {}
    let allAreas = []
    data.forEach(function (item) {
      if (allAreas.indexOf(item['区域']) === -1) {
        allAreas.push(item['区域'])
      }
      if (!dealData[item['加油站名称']]) {
        dealData[item['加油站名称']] = []
      }
      dealData[item['加油站名称']].push(item)
    })
    dispatch('setAllAreas', allAreas)
    let delPData = []
    // let oilStations = []
    for (let key in dealData) {
      // oilStations.push(key)
      let newPData = dealData[key].sort(function (a, b) {
        return a['油品名称'] > b['油品名称']
      })
      let oneOil = {'oil': key, data: newPData}
      delPData.push(oneOil)
    }
    // dispatch('setHisGasList', oilStations)
    dispatch('setHisJxcDatas', delPData)
  },
  setHisGasList ({ commit, dispatch, getters }, data) {
    commit('setHisGasList', data)
    if (!getters.selectHisGas && data.length > 0) {
      dispatch('setSelectHisGas', data[0])
    }
  },
  setSelectHisGas ({ commit }, data) {
    commit('setSelectHisGas', data)
  },
  setHisJxcDatas ({ commit, dispatch }, data) {
    commit('setHisJxcDatas', data)
    dispatch('checkHisJxcData')
  },
  setErrorHisJxcDatas ({ commit, dispatch }, data) {
    commit('setErrorHisJxcDatas', data)
    if (data.length === 0) {
      dispatch('setFlowStatus', 20)
    }
  }
}

const mutations = {
  setAllAreas (state, data) {
    state.allAreas = data
  },
  setAreaHisJxcDatas (state, data) {
    state.areaHisJxcDatas = data
  },
  setHisGasList (state, data) {
    state.hisGasList = data
  },
  setSelectHisGas (state, data) {
    state.selectHisGas = data
  },
  setHisJxcDatas (state, data) {
    state.hisJxcDatas = data
  },
  setErrorHisJxcDatas (state, data) {
    state.errorHisJxcDatas = data
  },
  editOneHisJxcData (state, data) {
    state.hisJxcDatas.forEach(function (item) {
      if (item.oil === data.data['加油站名称']) {
        item.data.forEach(function (itemD) {
          if ((itemD['加油站名称'] === data.data['加油站名称'] || itemD['油品名称'].label === data.data['油品名称']) && itemD['日期'] === data.data['日期'] && itemD['罐号'] === data.data['罐号']) {
            itemD[data.key] = data.value
            goUpdateInvoicingData(data)
          }
        })
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/oil/check_data.js